<template>
  <font class="iconfont">&#xe61a;</font>
</template>

<script>
export default {
  name: "v-icon-close"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/v-icon-close.vue